import Accounts from 'in-meeting-experience-ui-components/components/accounts/Accounts/Accounts';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { routes, unauthorizedRoutesParam } from '../constants/routes';
import { fetchUserInfo } from '../data/api/authApi';
import { fetchUserAccountsV2 } from '../data/api/userApi';
import useOauthPopup from '../hooks/useOauthPopup';
import useTracker from '../hooks/useTracker';
import { canViewParticipantsSelector } from '../slices/google/selectors';
import { getExternalAuthUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
function AccountsPage() {
  const canViewParticipants = useSelector(canViewParticipantsSelector);
  const usageTracker = useTracker();
  const openPopUp = useOauthPopup();
  const openUrl = () => {
    openPopUp(getExternalAuthUrl());
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ACCOUNTS_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Accounts, {
      unauthorizedRoutesParam: unauthorizedRoutesParam,
      routes: {
        contacts: '',
        associations: '',
        base: routes.base,
        accounts: routes.accounts,
        reconnect: routes.reconnect
      },
      apiWrapper: {
        fetchAccounts: fetchUserAccountsV2,
        fetchUserInfo
      },
      canViewParticipants: canViewParticipants !== null && canViewParticipants !== void 0 ? canViewParticipants : false,
      usageTracker: usageTracker,
      openUrl: openUrl
    })
  });
}
export default AccountsPage;